import { LastMessageSystem } from '@halo/ui-chat-react';
import { Text } from '@chakra-ui/react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgGroupMediaCloseContentProps } from './msg-group-media-close-content';
import { MsgGroupMediaCloseContent } from './msg-group-media-close-content';

export interface MsgGroupMediaClosePreviewProps extends MsgGroupMediaCloseContentProps {}

export const MsgGroupMediaClosePreview = memo(function MsgGroupMediaClosePreview({
  message,
}: MsgGroupMediaClosePreviewProps) {
  const { type } = message.payload;
  const { title } = useMsgMediaTitle({ type });
  const { t } = useTranslation();

  return (
    <LastMessageSystem>
      <Text as="span" color="fg.muted">
        {title}
      </Text>
      <MsgGroupMediaCloseContent message={message}>
        {({ typeDisplay, duration }) => (
          <Text as="span" color="fg.muted" px="1">
            {t('chat.callClosedText', { type: typeDisplay, duration: duration })}
          </Text>
        )}
      </MsgGroupMediaCloseContent>
    </LastMessageSystem>
  );
});
